<!-- eslint-disable vue/no-v-html -->
<template>
    <div class="setting-wrapper">
        <div class="setting">
            <span class="h4 lg:w-1/5">
                {{ title }}
            </span>

            <div class="flex flex-col lg:flex-row">
                <hardware-radio-option
                    v-for="option in options"
                    :key="option.value"
                    v-model="localSelected"
                    :option="option"
                />
            </div>
        </div>
        <div
            v-if="localSelectedDescription"
            class="ml-0 lg:ml-auto pb-2xl w-full lg:w-4/5 text-sm text-neutral-dark hidden lg:block"
            v-html="localSelectedDescription"
        />
    </div>
</template>

<script>
import HardwareRadioOption from './HardwareRadioOption.vue';

export default {
    components: { HardwareRadioOption },
    model: {
        prop: 'selected',
        event: 'input',
    },
    props: {
        description: {
            required: false,
            type: String,
            default: null,
        },
        title: {
            required: true,
            type: String,
        },
        options: {
            required: true,
            type: Array,
        },
        selected: {
            type: [String, Number],
            required: false,
            default: null,
        },
    },
    computed: {
        localSelected: {
            get() {
                return this.selected;
            },
            set(localState) {
                this.$emit('input', localState);
            },
        },
        localSelectedDescription() {
            if (! this.localSelected) {
                return null;
            }

            const selected = this.options.find(option => option.value === this.localSelected);

            if (! selected || ! selected.description) {
                return null;
            }

            return selected.description;
        },
    },
};
</script>

<style scoped>

</style>
